import * as firebase from "firebase";
import 'firebase/firestore';

import {initFirestorter} from 'firestorter';

var config = {
    apiKey: "AIzaSyCcIISYc31fNFCrsaymeupmosqZiF8dJ8A",
    authDomain: "hoomiz-p0llux.firebaseapp.com",
    databaseURL: "https://hoomiz-p0llux.firebaseio.com",
    projectId: "hoomiz-p0llux",
    storageBucket: "hoomiz-p0llux.appspot.com",
    messagingSenderId: "657545741906"
};
if (!firebase.apps.length) {
  firebase.initializeApp(config);
  initFirestorter({firebase: firebase});
}

const db = firebase.firestore();
const auth = firebase.auth();
export const doLogin = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);
export const doLogout = () =>
  auth.signOut();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js